import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ThemeName } from '@sc/data-access-models';
import cssVars from 'css-vars-ponyfill';
import { ConfigurationService } from '@sc/data-access-configuration';

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class ThemesManagerService {
  private readonly _selectedTheme: ThemeName = 'aari-theme-default';

  constructor(
    private readonly configService: ConfigurationService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this._selectedTheme = this.configService.getConfig().theme;

    this.addThemeClass(this._selectedTheme);
    this.addThemeLink(this._selectedTheme);
    this.fallbackCssVariablesOldBrowser();
  }

  private addThemeClass(styleName: ThemeName) {
    const { classList } = this.document.body;
    const classesString = classList.toString();
    const classes = classesString ? classesString.split(' ') : [];
    classes.forEach((className) => {
      if (className.indexOf('aari-theme-') > -1) {
        this.document.body.classList.remove(className);
      }
    });
    this.document.body.classList.add(styleName);
  }

  private addThemeLink(styleName: ThemeName) {
    const head = this.document.getElementsByTagName('head')[0];

    const themeLink = this.document.getElementById(
      'aari-theme'
    ) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = `${styleName}.css`;
    } else {
      const style = this.document.createElement('link');
      style.id = 'aari-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}.css`;

      head.appendChild(style);
    }
  }

  private fallbackCssVariablesOldBrowser() {
    cssVars({
      watch: true,
      rootElement: this.document,
      shadowDOM: true,
      include: 'link[rel=stylesheet],style',
      onlyLegacy: true,
      preserveStatic: true,
      preserveVars: true,
      silent: false,
      updateDOM: true,
      updateURLs: false,
    });
  }
}
